
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import VendedorData from "./VendedorData";

export default {
  name: "app-vendedor-update",
  data() {
    return {
      vendedor: {},
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getVendedor(id) {
      const { data } = await this.$http.post("/vendedor/find", {
        id_vendedor: id,
      });
      return data;
    },
    async getInit() {
      try {
        const id = this.$route.params.id;
        this.setLoading(true);

        const vendedor = await this.getVendedor(id);
        this.setLoading(false);

        if (!vendedor.id_vendedor || vendedor == null) {
          this.$router.push({ name: "vendedorLista" });

          return this.$toast.error("Vendedor não encontrado!");
        }

        this.vendedor = vendedor;
      } catch (e) {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    await this.getInit();
  },
};
